// @flow

import * as React from 'react'
import { Label, Dimmer, Loader, Segment } from 'semantic-ui-react'
import { store } from '../store/index'
import { createWave, setCampaignStatus, dropWave, addUser, removeUser, type CardSummary } from '../store/campaigns'

import SummarySection from './summary-section'
import WavesSection from './waves-section'
import UsersSection from './users-section'
import ActionsSection from './actions-section'

import type { User } from '../store/manage-users'

type Props = {|
  campaignName: string,
  headerContent?: React.Node,
  isActive: boolean,
  isAdmin: boolean,
  isViewer: boolean,
  isPending: boolean,
  waves: Array<Object>,
  summary: CardSummary,
  users: Array<User>,
  systemUsers: Array<User>,
  currentUser: string,
  viewType: 'list' | 'grid' | 'block',
  onDelete: (username: string) => void,
|}

class CampaignCard extends React.Component<Props> {
  static defaultProps = {
    campaignName: '',
    isActive: true,
    isPending: false,
    currentUser: '',
    onDelete: () => {},
    summary: {
      WEB: { visits: 0, rate: 0 },
      F2F: { visits: 0, rate: 0 },
      PHONE: { visits: 0, rate: 0 },
      total: { visits: 0, rate: 0 },
      wave: { num_waves: 0, last_wave: '', visits_last_wave: 0 },
    },
  }
  onAddWaveHandler = (waveName: string) => {
    if (!this.props.campaignName === '') return
    store.dispatch(createWave(this.props.campaignName, waveName.trim().replace(/ /g, '_')))
  }

  dropWaveHandler = (waveName: string) => {
    if (!this.props.campaignName === '') return
    store.dispatch(dropWave(this.props.campaignName, waveName))
  }

  onAddUserHandler = (username: string) => {
    if (!this.props.campaignName === '') return
    store.dispatch(addUser(this.props.campaignName, username))
  }

  onRemoveUserHandler = (username: string) => {
    if (!this.props.campaignName === '') return
    store.dispatch(removeUser(this.props.campaignName, username))
  }

  dropCampaignHandler = () => {
    if (!this.props.campaignName === '') return
    this.props.onDelete(this.props.campaignName)
  }

  setCampaignStatusHandler = () => {
    if (!this.props.campaignName === '') return
    store.dispatch(setCampaignStatus(this.props.campaignName, !this.props.isActive))
  }

  render() {
    // Campaign editing or ghost element
    let dimmed = this.props.isPending || this.props.campaignName === ''
    // Active campaign or ghost element
    let titleColor = this.props.isActive || this.props.campaignName === '' ? 'blue' : 'red'

    let columns = this.props.viewType === 'grid' ? 'one' : 'two'

    return (
      <Dimmer.Dimmable as={Segment} dimmed={dimmed}>
        <Dimmer active={dimmed} inverted style={{ zIndex: '700' }}>
          {this.props.campaignName !== '' && <Loader />}
        </Dimmer>
        <Label attached="top" color={titleColor} size="big" style={{ zIndex: '710' }}>
          {this.props.campaignName}
          {this.props.headerContent}
        </Label>
        <div style={{ height: '5ex' }} />
        <div className={'ui stackable ' + columns + ' column grid'}>
          <SummarySection summary={this.props.summary} />
          <WavesSection
            waves={this.props.waves}
            waveSummary={this.props.summary.wave}
            isAdmin={this.props.isAdmin}
            campaignName={this.props.campaignName}
            onAddWave={this.onAddWaveHandler}
            onDropWave={this.dropWaveHandler}
          />
          <UsersSection
            isAdmin={this.props.isAdmin}
            currentUser={this.props.currentUser}
            users={this.props.users}
            systemUsers={this.props.systemUsers}
            onAddUser={this.onAddUserHandler}
            onRemoveUser={this.onRemoveUserHandler}
          />
          <ActionsSection
            isAdmin={this.props.isAdmin}
            isViewer={this.props.isViewer}
            isActive={this.props.isActive}
            currentUser={this.props.currentUser}
            campaignName={this.props.campaignName}
            wavesCount={this.props.waves.length}
            totalVisits={this.props.summary.total.visits}
            onSetCampaignStatus={this.setCampaignStatusHandler}
            onDropCampaign={this.dropCampaignHandler}
          />
        </div>
      </Dimmer.Dimmable>
    )
  }
}

export default CampaignCard



// WEBPACK FOOTER //
// ./src/campaigns/campaign-card.js